import script from "./ProceedQuotationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceedQuotationItem.vue?vue&type=script&setup=true&lang=js"

import "./ProceedQuotationItem.vue?vue&type=style&index=0&id=17c7d66e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c7d66e"]])

export default __exports__